
import './AboutDetails.css';
import flat3 from '../assets/Residential/Apartment/flat4.png';
const AboutDetails = () => (
  <section className="about-details-page">
    <div className="container">
      <div className="our-story-block">
        <h3 className="our-story-title">ABOUT US</h3>
        <div className="our-story-content">
          <div className="our-story-text">
            <p>
              Designing Space. Defining Style. Delivering Vision.

Welcome to 10 Designs – where architecture meets imagination.

Based in Hyderabad, 10 Designs is a multidisciplinary design studio that unites architecture, interiors, landscape, and more under one creative roof. With a focus on smart planning, refined aesthetics, and future-ready solutions, we turn ideas into iconic spaces—residential, commercial, and industrial alike.

Whether you're building your dream home, designing a dynamic workplace, or developing an efficient industrial unit, we approach every project with clarity, creativity, and care—delivering designs that not only inspire but also function flawlessly.

            </p>
            <h2>What We Do</h2>
            <p>
At 10 Designs, we create thoughtful architectural and interior solutions that blend style, function, and smart planning. From concept to completion, our turnkey project management ensures a seamless experience. We offer optimized space planning, immersive 3D visualizations, and sustainable landscape design. Our modular and PVC furniture is tailored for modern, efficient living. We also specialize in commercial and industrial spaces that grow with your business.            </p>
            
          </div>
          <div className="our-story-image">
            <img src={flat3} alt="Our Story" />
            
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutDetails; 